//jQuery.noConflict();
(function($){

    if(typeof acf === 'undefined')
        return;

    // ACF Extended: After Preview Ajax
    acf.addAction('acfe/fields/flexible_content/preview', function(response, $el, $layout, ajaxData){

        var number = parseInt($layout.find('.acf-fc-layout-order:first').text(), 10);

        var result = "Question = " + (parseInt(number, 10) + 1);
        
        $layout.find('.tpl-diag .tpl-diag-form .tpl-diag-question-number span.vahu-flex-row-index').html(number);

        $layout.find('.tpl-diag .tpl-diag-form .list-question .responses span.vahu-flex-next-question').html(result);
    });

    // ACF: After Drag & Drop
    acf.addAction('new_field/type=flexible_content', function(flexible){

        flexible.$input().on('change', function(e){

            flexible.render();
            flexible.$layouts().each(function(i){
                $(this).find('.tpl-diag .tpl-diag-form .tpl-diag-question-number span.vahu-flex-row-index').html(i+1);
                var result = "Question = " + (i+2);
                $(this).find('.tpl-diag .tpl-diag-form .list-question .responses span.vahu-flex-next-question').html(result);
            });
        });
    });


    /**
     * Field: Advanced Link
     */
    // var ACF_Advanced_Link_VAL = acf.Field.extend({
		
	// 	type: 'acf_advanced_link_val',
		
	// 	events: {
	// 		'click a[data-name="add"]': 	'onClickEdit',
	// 		'click a[data-name="edit"]': 	'onClickEdit',
	// 		'click a[data-name="remove"]':	'onClickRemove',
	// 	},
		
	// 	$control: function(){
	// 		return this.$('.acf-link');
	// 	},
        
    //     initialize: function(){
            
    //         this.on('change', '.input-post', this.onPostChange);
            
    //     },
		
	// 	getValue: function(){

	// 		// return
    //         var data = {
	// 			type:   this.$('.input-type :checked').val(),
	// 			title:  this.$('.input-title').val(),
	// 			url:    this.$('.input-url').val(),
	// 			post:   this.$('.input-post :selected').text(),
	// 			target: this.$('.input-target').is(':checked')
	// 		};
            
    //         if(data.type === 'post'){
                
    //             data.url = data.post;
                
    //         }
            
    //         return data;
            
	// 	},
		
	// 	setValue: function( val ){
			
	// 		// default
	// 		val = acf.parseArgs(val, {
	// 			remove:	false,
	// 			title:	'',
	// 			url:	'',
	// 			target:	false
	// 		});
			
	// 		// vars
	// 		var $div = this.$control();
			
	// 		// remove class
	// 		$div.removeClass('-value -external');
			
	// 		// add class
	// 		if(val.url)
    //             $div.addClass('-value');
            
	// 		if(val.target)
    //             $div.addClass('-external');
			
	// 		// update text
	// 		this.$('.link-title').html( val.title );
	// 		this.$('.link-url').attr('href', val.url).html( val.url );
			
	// 		// remove inputs data
    //         if(val.remove){
                
    //             this.$('.input-type :checked').prop('checked', false);
    //             this.$('.input-type [value="url"]').prop('checked', true).trigger('change');
    //             this.$('.input-title').val('');
    //             this.$('.input-target').prop('checked', false);
    //             this.$('.input-url').val('').trigger('change');
    //             this.$('.input-post').val('').trigger('change');
                
    //         }
            
	// 	},
		
	// 	onClickEdit: function(e, $el){
            
    //         var $modal = $el.closest('.acf-input').find('.acfe-modal');
            
    //         var title = $modal.attr('data-modal-title');
            
    //         var model = this;
            
    //         acfe.modal.open($modal, {
    //             title: title,
    //             size: 'small',
    //             onClose: function(){
    //                 model.onChange();
    //             }
    //         });
            
	// 	},
		
	// 	onClickRemove: function( e, $el ){
            
	// 		this.setValue({
	// 			remove:	true
	// 		});
            
	// 	},
		
	// 	onChange: function( e, $el ){
			
	// 		// get the changed value
	// 		var val = this.getValue();
			
	// 		// update inputs
	// 		this.setValue(val);
            
	// 	},
        
	// 	onPostChange: function(e){

    //         var $el = $(this);
    //         var model = acf.getInstance($el.closest('.acf-field-acfe-advanced-link'));
            
	// 	},
		
	// });
	
    // acf.registerFieldType(ACF_Advanced_Link_VAL);


    //     /**
    //  * Field: Post Object - Ajax
    //  */
    // acf.addFilter('select2_ajax_data', function(ajaxData, data, $el, field, select){
        
    //     if(field.get('key') !== 'post' || field.get('type') !== 'post_object')
    //         return ajaxData;

    //     console.log($el.closest('.acf-field-acf-advanced-link-val'));
        
    //     var advanced_link = acf.getInstance($el.closest('.acf-field-acf-advanced-link-val'));

    //     console.log(advanced_link);

    //     if(advanced_link){
    //         ajaxData.field_key = advanced_link.get('key');
    //     }
        
    //     return ajaxData;
        
    // });
    

    

})(jQuery);